$.fn.typeahead = function (options) {

    let _options = $.extend(
        {
            textproperty: "name",
            source: function (query) {
                return new Promise((resolve, reject) => {
                    setTimeout(function () {
                        if (!query) return [];
                        var items = [{ name: "Item 1", id: 1 }, { name: "Item 2", id: 2 }];
                        var found_items = $.grep(items, function (i) {
                            return i.name.indexOf(query) > -1;
                        });
                        resolve(found_items);
                    }, 200);
                });
            }
        },
        options);

    let currentFocus,
        $typeahead = this,
        timeout = null;

    async function getItems(query) {
        var items = await _options.source(query);
        $typeahead.trigger("search", items);
        return items;
    }

    $typeahead.on('input', function (e) {

        if (timeout !== null) clearTimeout(timeout);

        timeout = setTimeout(async function () {
        
            var a, b, i, val = $typeahead.val();

            var items = await getItems(val);

            closeAllLists();

            if (!items || items.length == 0) return false;

            currentFocus = -1;

            a = $("<ul>");

            a.attr("id", $typeahead.attr("id") + "typeahead-list");
            a.attr("class", "typeahead-items");
            $typeahead.parent().append(a);

            for (i = 0; i < items.length; i++) {
                b = $("<li>");
                b.html(Utils.GetObjectPropertyValueByString(items[i], _options.textproperty));
                b.data("item", items[i]);
                b.click(function (e) {
                    let $this = $(this),
                        $item = $this.data("item");

                    $typeahead.val(Utils.GetObjectPropertyValueByString($item, _options.textproperty));
                    $typeahead.data("item", $item);

                    closeAllLists();

                    $typeahead.trigger("selected", $item);
                });

                a.append(b);
            }
        }, 200);
    });

    $typeahead.on("keydown", function (e) {
        var $x = $("#" + $typeahead.attr("id") + "typeahead-list");
        if ($x) $x = $("li", $x);
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive($x);
        } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive($x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if ($x) $x[currentFocus].click();
            }
        }
    });

    function addActive($x) {
        /*a function to classify an item as "active":*/
        if (!$x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive($x);
        if (currentFocus >= $x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = ($x.length - 1);
        /*add class "autocomplete-active":*/
        $x.eq(currentFocus).addClass("typeahead-active");
    }

    function removeActive($x) {
        $x.removeClass("typeahead-active");
    }

    function closeAllLists(elmnt) {
        var x = $(".typeahead-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != this) {
                x[i].remove();
            }
        }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
};